<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>WensoulChain - AI-Driven Cultural Creative Design Cloud Platform</h1>
        </div>
        <div class="picture">
          <img src="../assets/project17_3.png.webp" />
        </div>
        <div class="paper_published">
          Project won the Gold Award in the provincial competition of the 2025 China International College Students' Innovation Competition (Ranked No.1 in its track) (Project Leader).
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="abstract">
          WensoulChain provides museums, cultural tourism IP operators, and cultural & creative enterprises with an intelligent and data-driven one-stop solution for IP operation and commercialization.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">Three Intelligent Engines for Efficient IP Creation</div>
        <div class="text">
          "WensoulChain" integrates three core engines into one system: market trend insight, IP image generation, and IP activation.
          <br /><br />
          IP Insight Engine: intelligent market trend analysis, identification of high-potential IPs, and IP operation strategy recommendations.
          <br /><br />
          IP Generation Engine: extracts design elements through cultural semantic DNA to quickly generate IP character images.
          <br /><br />
          IP Activation Engine: transforms cultural knowledge graphs into cultural creative products and dynamic narrative content adaptable to multiple scenarios.
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_3.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="text">
          WensoulChain builds a closed-loop process from insight to generation and then activation, significantly improving the end-to-end efficiency of cultural IP design and commercialization.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">Connecting the Industry Ecosystem, Creating Conversational Scenarios</div>
        <div class="text">
          "WensoulChain" is not only a tool platform, but also an ecosystem empowerment system that links cultural resource providers, designers, manufacturers, and consumers.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="10"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project17",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.abstract {
  margin-top: 20px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
